module.exports = __webpack_public_path__ + "f73bb30163ce624e35ca2e620a3e73fd.pdf";